import priceTableData from "../refdata/prices.json"

export default function PriceTable() {
    return <>
        <div>
            <div className="container">
            
            {priceTableData.Tables.map((ptable) => (
                <div key={ptable.TableName}>
                    <div className="card mx-auto shadow-lg" style={{"width" : "100%"}}>

                        <div className="card-header"><h3 className="fw-bold">{ptable.TableName}</h3></div>
                        <div className="card-body">

                        <table className={"table table-bordered table-hover table-striped " + ptable.Colour}>
                            <thead className="table-dark">
                                <tr>
                                    <th scope="col">Type</th>
                                    <th scope="col">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ptable.Rows.map((row) => (

                                        <tr key={row.Text}><th scope="row">{row.Text}</th>
                                            <td className="text-end">{row.Price}</td>
                                        </tr>

                                ))}
                            </tbody>

                        </table>
                        </div>
                        <p className="fw-lighter p-1"><small>The above prices are applicable from {priceTableData.ApplicableDate} </small></p>
                    </div>
                    <br />
                    
                </div>
            ))}
            </div>

            
        </div>
    </>
}